import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import useCountryContext from 'core/hooks/useCountryContext';
import {
  CourierPosition,
  CourierPositionsRequest,
} from '../grpc/trafficUpdates_pb';
import { TrafficUpdatesGrpcServiceClient } from '../grpc/TrafficUpdatesServiceClientPb';

type CourierPositionsResult = {
  courierPositions: CourierPosition[];
};

function useCourierPositionsDataStore(
  date: string | null,
  courierId: number | null,
  client: TrafficUpdatesGrpcServiceClient,
): CourierPositionsResult {
  const [courierPositions, setCourierPositions] = useState<CourierPosition[]>(
    [],
  );
  const auth = useAuth();
  const token = auth.user?.access_token;
  const { countryContext } = useCountryContext();

  useEffect(() => {
    if (!courierId || courierId <= 0 || !date) {
      return () => {};
    }

    const request = new CourierPositionsRequest();
    request.setCourierId(courierId);
    request.setDateTime(date);
    request.setCountryCode(countryContext?.toString() ?? '');
    const deadlineInMs = 5000;

    const courierPositionsStream = client.streamFromServerCourierPositions(
      request,
      {
        Authorization: `Bearer ${token}`,
        deadline: deadlineInMs.toString(),
      },
    );

    courierPositionsStream.on('data', (response) => {
      setCourierPositions(response.getCourierPositionsList());
    });

    courierPositionsStream.on('error', (error) => {
      console.log(
        `Server streaming has following error message: ${error.message} and error code: ${error.code}`,
      );
    });

    courierPositionsStream.on('end', () => {
      console.log('Server ended streaming.');
    });

    return () => {
      if (courierPositionsStream) {
        courierPositionsStream.cancel();
        console.log('Streaming cancelled');
      }
    };
  }, [courierId, date, token, client, countryContext]);

  return {
    courierPositions,
  };
}

export default useCourierPositionsDataStore;
